import templateUrl from "emun.order/review-orders/review-order.htm";
import open from "webmodals/open";
import modals from "webmodals/modals";
import orderConfig from "emun.order/order.config";
import ServiceBus from 'servicestack/service-bus'
import basicController from "servicestack/basic.controller.properties";

class controller {
	constructor($scope, options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = $ctrl.$session.bus;
		$ctrl.title = options.title || "Review Order...";
		$ctrl.order = options.order;
		$ctrl.config = orderConfig;
		$ctrl.request = {
			OrderNumber: $ctrl.order.id,
			RetailerId: $ctrl.order.retailerId,
			ShipId: $ctrl.order.shippingLocationId,
			NewCustId: "",
			NewShipId: ""
		};
		$ctrl.submit = () => {
			$ctrl.bus.send("ApproveOrder.json", $ctrl.request).then(function (response) {
				$ctrl.$close();
			});
		};
	}

}

export default {
	open(options) {
		return modals.open(
			Object.assign(
				{
					templateUrl,
					resolve: {
						options: () => options
					},
					bindToController: true,
					controller,
					controllerAs: "$ctrl",
					size: "md"
				},
				(options || {}).modal
			)
		).result;
	}
};

